<template>
    <b-modal
        id="module-management-add-users-modal"
        modal-class="apprentice-default-modal"
        :title="$t('modules.add_student')"
        :ok-title="$t('common.close')"
        ok-only
        size="lg"
        @show="onShow">
        <div
            class="errors"
            v-if="hasErrors">
            <b-alert
                show
                variant="danger">
                {{ $t('modules.you_first_have_to_select_a_period_before_you_can_add_a_student') }}
            </b-alert>
        </div>

        <design-2021-apprentice-data-table
            :fields="fields"
            :items="availableUsers"
            :show-empty="true">
            <template #options>
                <design2021-apprentice-multiselect-component
                    v-model="selectedPeriod"
                    :options="periods"
                    track-by="id"
                    label="name"
                    :placeholder="$t('modules.choose_period')"
                    :multiple-select="false"
                    :allow-empty="false">
                </design2021-apprentice-multiselect-component>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button
                    class="btn-user-add btn-add-user-to-module"
                    variant="primary-icon-only"
                    @click="save(row.item, $event)">
                </b-button>
            </template>

            <template #empty>
                <div class="not-found with-header user-list-empty">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('modules.no_students_found_to_be_add') }}.</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';
import Design2021ApprenticeMultiselectComponent from '../../common/design-2021-apprentice-multiselect-component.vue';

export default {
    name: 'design-2021-module-management-edit-participant-add-users-modal-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: ['moduleIn', 'selectedDateId', 'selectedUserIds', 'modulePeriodsIn'],
    data() {
        return {
            users: [],
            loaded: false,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.add'),
                },
            ],
            periods: [
                {
                    id: null,
                    name: this.$t('modules.choose_period'),
                    $isDisabled: true,
                },
                ...this.modulePeriodsIn,
            ],
            selectedPeriod: null,
            hasErrors: false,
        };
    },

    mounted() {
        if (this.modulePeriodsIn.length === 1) {
            this.selectedPeriod = this.modulePeriodsIn[0].id;
        }
    },

    computed: {
        availableUsers() {
            return this.users.filter((user) => !this.selectedUserIds.includes(user.id));
        },
    },

    methods: {
        save(user, bvModalEvent) {
            this.checkForErrors();

            if (this.hasErrors) {
                bvModalEvent.preventDefault();
                return;
            }

            let data = {
                module_id: this.moduleIn.id,
                module_date_id: this.selectedPeriod.module_date_id,
            };

            this.axios.post(this.routes.moduleUserStore(user.id), data).then(
                (response) => {
                    user.addRelation('module_users', response.data);
                    this.users = this.users.filter((available_user) => available_user.id !== user.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            if (!this.loaded) {
                this.users = [];
                this.filteredUsers = [];

                this.alert.loading();

                this.axios.get(this.routes.moduleGetUsers()).then(
                    (response) => {
                        ords.use('user').add(response.data);

                        ords.use('user')
                            .where('type', '=', 'student')
                            .get()
                            .subscribe((user) => {
                                this.users = user;
                            });

                        this.alert.loaded();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );

                this.loaded = true;
            }
        },

        checkForErrors() {
            this.hasErrors = false;
            if (this.selectedPeriod === null) {
                this.hasErrors = true;
            }
        },
    },
};
</script>

<style scoped></style>
